import { render, staticRenderFns } from "./qqqxMBTI.vue?vue&type=template&id=b6fb34da&scoped=true&"
import script from "./qqqxMBTI.vue?vue&type=script&lang=js&"
export * from "./qqqxMBTI.vue?vue&type=script&lang=js&"
import style0 from "./qqqxMBTI.vue?vue&type=style&index=0&id=b6fb34da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6fb34da",
  null
  
)

export default component.exports